import { CommandType } from "~app/common/services/cqs/CommandType";
import { AnmalanTradslagBaseCommand } from "./AnmalanTradslagBaseCommand";

export class DeleteAnmalanTradslagCommand extends AnmalanTradslagBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteAnmalanTradslagCommand";

    constructor(atgardGuid: string, anmalanTradslagGuid: string) {
        super(atgardGuid, anmalanTradslagGuid, DeleteAnmalanTradslagCommand.$type, CommandType.Delete);
    }
}
